import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import toast from "react-hot-toast";
import { V_URL } from "../../../../BaseUrl";

export const getTransactionDropdown = createAsyncThunk(
    '/user/get-transaction-dropdown',
    async () => {
        try {
            const myurl = `${V_URL}/prosafe/get-transformation-transactions`;
            const response = await axios({
                method: 'get',
                url: myurl,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    Authorization: "Bearer " + localStorage.getItem('PAY_USER_TOKEN')
                },
            });

            const transaction = response.data;

            if (transaction.success === true) {
                return transaction;
            } else {
                throw new Error(transaction);
            }
        } catch (error) {
            toast.error(error.response.data.message);
            return error;
        }
    }
);

const getTransactionDropdownSlice = createSlice({
    name: "getTransactionDropdown",
    initialState: {
        user: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getTransactionDropdown.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getTransactionDropdown.fulfilled, (state, action) => {
                state.user = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(getTransactionDropdown.rejected, (state, action) => {
                state.user = null;
                state.loading = false;
                state.error = action.error.message;
            });
    }
})

export default getTransactionDropdownSlice.reducer;